var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign__md-contents"},[_c('div',{staticClass:"campaign__md-contents-body",domProps:{"innerHTML":_vm._s(_vm.lastMdContentsHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }